import { logError } from 'lib/sentry/logError';
import { MenuItem } from 'shared';
import { removeFromArrayById } from 'shared_DEPRECATED/utils';

import {
  useDeleteGoalBreakdownChallengeMutation__DEPRECATED,
  useGoalQueryActions,
} from 'features/goal/hooks';
import { IGoal } from 'features/goal/types';

type TGoalChallengeCardRemoveButton = {
  challengeId: string;
  focusAreaId?: string;
};

export const GoalChallengeCardRemoveButton = ({
  challengeId,
  focusAreaId,
}: TGoalChallengeCardRemoveButton) => {
  const {
    cancelGoalQueries,
    getGoalQuery,
    updateGoalQueryData,
    invalidateGoalQuery,
  } = useGoalQueryActions();

  const { mutateAsync: deleteGoalBreakdownChallenge } =
    useDeleteGoalBreakdownChallengeMutation__DEPRECATED({
      challengeId,
      focusAreaId,
      options: {
        onMutate: async () => {
          cancelGoalQueries();
          const previousValue = getGoalQuery();

          updateGoalQueryData((draft: IGoal) => {
            if (focusAreaId) {
              const focusAreaIndex = draft.focusAreas.findIndex(
                (fa) => fa.focusAreaId === focusAreaId
              );

              if (focusAreaIndex !== -1) {
                draft.focusAreas[focusAreaIndex].challenges =
                  removeFromArrayById({
                    array: draft.focusAreas[focusAreaIndex].challenges,
                    id: challengeId,
                    idProperty: 'challengeId',
                  });
              }
            } else {
              draft.challenges = removeFromArrayById({
                array: draft.challenges,
                id: challengeId,
                idProperty: 'challengeId',
              });
            }
          });

          return { previousValue };
        },
        onSettled: () => {
          invalidateGoalQuery();
        },
        onError: (err: Error) => {
          logError(err);
        },
      },
    });

  return (
    <MenuItem
      color="var(--fgDanger)"
      //@ts-ignore
      onClick={deleteGoalBreakdownChallenge}
    >
      Remove
    </MenuItem>
  );
};
